var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-small"},[_c('small',{staticClass:"title-small"},[_vm._v(_vm._s(_vm.row[_vm.column.small])+" "+_vm._s(_vm.row[_vm.column.tipo]))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.row[_vm.column.field]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }